import { SettingsAdminActiveDirectoryListContainer } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/settings-integrations-active-directory-list.container';

export const SettingsActiveDirectoryListsScene = () => <SettingsAdminActiveDirectoryListContainer />;

export default SettingsActiveDirectoryListsScene;
